import { BASE_URL } from "../../../helpers/config";
import { showToast, showAlert } from "../../../utils/helpers/ShowToast";
import authorizedAxios from "../../../helpers/authorizedAxios";

export const SET_VILLAGES = "SET_VILLAGES";
export const SET_VILLAGES_LOADING = "SET_VILLAGES_LOADING";
export const SET_VILLAGES_ERROR = "SET_VILLAGES_ERROR";

export const fetchVillages = (limit = 100, page = 1, search = "", district_id = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_VILLAGES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/villages", {
        params: { limit, page, search, district_id },
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_VILLAGES,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_VILLAGES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data.",
      });
    } finally {
      dispatch({ type: SET_VILLAGES_LOADING, status: false });
    }
  };
};

export const addVillage = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_VILLAGES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/villages`, data), {
        loading: "Menyimpan data...",
        success: "Data Kelurahan berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data Kelurahan!",
      });

      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data Kelurahan berhasil ditambahkan!",
        });
        dispatch(fetchVillages());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_VILLAGES_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
      return false;
    } finally {
      dispatch({ type: SET_VILLAGES_LOADING, status: false });
    }
  };
};

export const updateVillage = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_VILLAGES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/villages/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data Kelurahan berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data Kelurahan!",
      });

      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data Kelurahan berhasil diupdate!",
        });
        dispatch(fetchVillages());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_VILLAGES_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
      return false;
    } finally {
      dispatch({ type: SET_VILLAGES_LOADING, status: false });
    }
  };
};

export const deleteVillage = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_VILLAGES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/villages/${id}`), {
        loading: "Menghapus data...",
        success: "Data Kelurahan berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data Kelurahan!",
      });

      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data Kelurahan berhasil dihapus!",
        });
        dispatch(fetchVillages());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_VILLAGES_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
    } finally {
      dispatch({ type: SET_VILLAGES_LOADING, status: false });
    }
  };
};
